import { useSignal } from '@preact/signals';

function BadgeColor(badge) {
  const b = (badge || '').toLowerCase();
  if (b.includes('stock') || b.includes('available') || b.includes('new')) return 'mc-badge-green';
  if (b.includes('sale') || b.includes('off') || b.includes('deal')) return 'mc-badge-orange';
  if (b.includes('out') || b.includes('unavailable') || b.includes('sold')) return 'mc-badge-red';
  return 'mc-badge-blue';
}

function ProductImage({ src, title }) {
  const errored = useSignal(false);
  if (!src || errored.value) {
    return (
      <div class="mc-pc-img-placeholder" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
          <polyline points="21 15 16 10 5 21"/>
        </svg>
      </div>
    );
  }
  return (
    <img
      class="mc-pc-img"
      src={src}
      alt={title || ''}
      loading="lazy"
      onError={() => { errored.value = true; }}
    />
  );
}

export function ProductCard({ card }) {
  const { title, subtitle, badge, meta, url, image } = card;
  const handleClick = url ? () => window.open(url, '_blank', 'noopener noreferrer') : undefined;

  return (
    <div
      class={`mc-pc${url ? ' mc-pc-clickable' : ''}`}
      onClick={handleClick}
      role={url ? 'button' : undefined}
      tabIndex={url ? 0 : undefined}
      onKeyDown={url ? (e) => { if (e.key === 'Enter' || e.key === ' ') handleClick(); } : undefined}
      aria-label={title || undefined}
    >
      {/* Only show image wrapper when an image URL is provided */}
      {image && (
        <div class="mc-pc-img-wrap">
          <ProductImage src={image} title={title} />
        </div>
      )}
      <div class="mc-pc-body">
        {badge && <span class={`mc-badge ${BadgeColor(badge)}`}>{badge}</span>}
        {title    && <p class="mc-pc-title">{title}</p>}
        {subtitle && <p class="mc-pc-sub">{subtitle}</p>}
        {meta     && <p class="mc-pc-meta">{meta}</p>}
      </div>
      {url && (
        <div class="mc-pc-arrow" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
          </svg>
        </div>
      )}
    </div>
  );
}
